<template>
  <div class="nav-page">
    <header class="nav-head">
      <div class="nav-head-inner">
        <div class="sec-eyebrow">导航</div>
        <h1 class="nav-title">全站入口</h1>
        <p class="nav-intro">
          方案演示、自研产品、技术文章、开源仓库与联系方式都汇总在这一页。
          第一次来，建议先看行业方案的在线演示。
        </p>
      </div>
    </header>

    <section class="sec">
      <div class="sec-inner">
        <div class="group" v-for="g in navGroups" :key="g.title">
          <div class="group-side">
            <h2 class="group-title">{{ g.title }}</h2>
            <p class="group-desc">{{ g.desc }}</p>
          </div>
          <div class="group-links">
            <template v-for="l in g.links">
              <a
                v-if="l.external"
                class="nav-item"
                :key="l.name"
                :href="l.href"
                :target="isBlank(l.href) ? '_blank' : null"
                rel="noopener"
              >
                <span class="item-main">
                  <span class="item-name">{{ l.name }}</span>
                  <span class="item-desc">{{ l.desc }}</span>
                </span>
                <span class="item-arrow">&rarr;</span>
              </a>
              <router-link
                v-else
                class="nav-item"
                :key="l.name"
                :to="l.href"
              >
                <span class="item-main">
                  <span class="item-name">{{ l.name }}</span>
                  <span class="item-desc">{{ l.desc }}</span>
                </span>
                <span class="item-arrow">&rarr;</span>
              </router-link>
            </template>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { navGroups } from "@/assets/js/profile";

export default {
  name: "Nav",
  data() {
    return { navGroups };
  },
  methods: {
    // tel: 和 mailto: 不该开新窗口
    isBlank(href) {
      return /^https?:/.test(href);
    }
  },
  metaInfo: {
    title: "导航 - 穆雄雄",
    meta: [
      {
        name: "description",
        content:
          "穆雄雄的站点导航：区域慢病管理、数智长护监管、智慧电梯追溯三个方案演示，自研小程序，CSDN 与公众号，GitHub 与 Gitee 开源仓库，以及联系方式。"
      }
    ]
  }
};
</script>

<style scoped>
.nav-page {
  background: var(--bg);
}
.nav-head {
  padding: 120px 24px 56px;
  border-bottom: 1px solid var(--border-soft);
}
.nav-head-inner {
  max-width: var(--maxw);
  margin: 0 auto;
}
.nav-title {
  font-size: 46px;
  line-height: 1.22;
  font-weight: 600;
  letter-spacing: -1.2px;
  color: var(--ink);
  margin: 0 0 22px;
}
.nav-intro {
  font-size: 15.5px;
  line-height: 2;
  color: var(--ink-soft);
  max-width: 640px;
  margin: 0;
}

.group {
  display: flex;
  flex-wrap: wrap;
  padding: 44px 0;
  border-bottom: 1px solid var(--border);
}
.group:first-child {
  padding-top: 0;
}
.group:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.group-side {
  flex: 0 0 260px;
  padding-right: 40px;
}
.group-title {
  font-size: 22px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 10px;
  letter-spacing: -0.3px;
}
.group-desc {
  font-size: 13.5px;
  line-height: 1.85;
  color: var(--ink-faint);
  margin: 0;
}
.group-links {
  flex: 1 1 420px;
  min-width: 280px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
  align-content: start;
}
.nav-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 16px 18px;
  transition: border-color 0.18s ease, transform 0.18s ease;
}
.nav-item:hover {
  border-color: var(--accent);
  transform: translateX(3px);
}
.item-main {
  display: block;
  min-width: 0;
}
.item-name {
  display: block;
  font-size: 15px;
  font-weight: 500;
  color: var(--ink);
}
.item-desc {
  display: block;
  font-size: 13px;
  line-height: 1.7;
  color: var(--ink-soft);
  margin-top: 4px;
}
.item-arrow {
  font-size: 16px;
  color: var(--ink-faint);
  margin-left: 14px;
  flex: 0 0 auto;
}
.nav-item:hover .item-arrow {
  color: var(--accent);
}

@media (max-width: 900px) {
  .group-side {
    flex: 0 0 100%;
    padding-right: 0;
    margin-bottom: 20px;
  }
}
@media (max-width: 760px) {
  .nav-head {
    padding: 96px 20px 40px;
  }
  .nav-title {
    font-size: 32px;
  }
}
</style>
